
export default {
  props: {
    termsAndConditions: {
      type: Array,
      default: () => [],
    },
    buttonLabel: {
      type: String,
      default: "",
    },
    buttonColor: {
      type: String,
      default: "",
    },
  },
};
